var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ReportTitle',{attrs:{"tripId":_vm.tripReport.tripReportId,"tripName":_vm.tripReport.name,"tripBeginDt":_vm.tripReport.beginDt,"tripEndDt":_vm.tripReport.endDt,"privacySetting":_vm.tripReport.privacy,"locale":_vm.locale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }